import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Text, Stack, Button } from '@chakra-ui/react';
import { Helmet } from 'react-helmet';

import { PageHeader } from 'shared-components';

import { logout } from '../../../store/auth/actions';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';
import { CoreStatusExtended } from 'types';
import { getOfferOrIntakeMode } from '../../../store/selectors';
import { ProcessingMode } from '../../../components/pages/intakeSelector';
import { titleAppend } from '../../../utilities/head';
import { useSession } from 'shared-components/authentication';

const InactiveIntake: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const activeOffer = useSelector((state: ApplicationState) => state.offers.activeOffer);
  const offerOrIntake: ProcessingMode = useSelector(getOfferOrIntakeMode);
  const mode = offerOrIntake.toLowerCase();
  const session = useSession();

  const onLogout = async () => {
    await session.onLogout();
    dispatch(logout());
  };

  const pageTitle = () => {
    if (activeOffer?.status === CoreStatusExtended.NOT_TRIGGERED) {
      return <>Your {mode} is not yet ready for the CAS request process</>;
    } else {
      return <>CAS statements for your {mode} are not yet being processed</>;
    }
  };

  return (
    <Container as="main" my={{ base: 8, md: 16 }}>
      <Helmet>
        <title>
          {pageTitle()} {titleAppend}
        </title>
      </Helmet>

      <PageHeader>{pageTitle()}</PageHeader>

      <Text fontSize="lg">
        {activeOffer?.status === CoreStatusExtended.NOT_TRIGGERED ? (
          <>You cannot request a CAS for this {mode} yet</>
        ) : (
          <>The university has not started issuing CAS statements for this {mode} yet.</>
        )}
      </Text>

      <Text fontSize="lg">
        You will be contacted when it is time to return to this form and <i></i> request a CAS.
      </Text>

      <Stack mt={8} spacing={3}>
        <Button onClick={() => navigate('/intake-select')} variant="solid" size="lg">
          Go back
        </Button>

        <Button onClick={onLogout} size="lg">
          Log out
        </Button>
      </Stack>
    </Container>
  );
};

export default InactiveIntake;
